import { render, staticRenderFns } from "./TaskFiltersContainer.vue?vue&type=template&id=723f4b7e&scoped=true&lang=pug&"
import script from "./TaskFiltersContainer.vue?vue&type=script&lang=js&"
export * from "./TaskFiltersContainer.vue?vue&type=script&lang=js&"
import style0 from "./TaskFiltersContainer.vue?vue&type=style&index=0&id=723f4b7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723f4b7e",
  null
  
)

export default component.exports